import cx from 'classnames';
import React, { ElementType, HTMLAttributes } from 'react';

export type ModalBodyProps = {
  componentClass?: ElementType;
  bsClass?: string;
} & HTMLAttributes<HTMLElement>;

export const ModalBody: React.FC<ModalBodyProps> = ({
  componentClass: Component = 'div',
  className,
  bsClass = 'modal-body',
  ...rest
}) => {
  return (
    <Component {...rest} className={cx(bsClass, className)} />
  );
};
